var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 84.27",
    style: {
      enableBackground: "new 0 0 122.88 84.27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41,0h70.56c3.12,0,5.95,1.27,8,3.32c2.05,2.05,3.32,4.88,3.32,8v61.63c0,3.12-1.27,5.95-3.32,8 c-2.05,2.05-4.88,3.32-8,3.32H40.67l-0.18-0.01c-10.44-0.6-19.13-13.09-27.57-25.21C9.21,53.72,5.55,48.46,2.03,44.62L0,42.41 l2.01-2.23c4.39-4.89,8.55-10.75,12.56-16.39C23.35,11.41,31.45,0,41,0L41,0z M83.95,24.11c2.22-2.26,5.84-2.27,8.07-0.02 c2.23,2.24,2.24,5.9,0.02,8.15l-9.75,9.89l9.76,9.9c2.21,2.24,2.17,5.87-0.07,8.1c-2.24,2.24-5.84,2.23-8.05-0.01l-9.7-9.83 l-9.72,9.85c-2.22,2.26-5.84,2.27-8.07,0.02c-2.23-2.24-2.24-5.89-0.02-8.15l9.75-9.89l-9.76-9.9c-2.2-2.24-2.17-5.87,0.07-8.1 c2.24-2.24,5.84-2.23,8.05,0.01l9.7,9.83L83.95,24.11L83.95,24.11z M111.56,6.62H41c-6.15,0-13.3,10.07-21.06,20.98 c-3.55,5-7.22,10.17-11.1,14.77c3.19,3.81,6.33,8.33,9.51,12.89c7.48,10.74,15.18,21.8,22.34,22.38h70.87 c1.29,0,2.46-0.53,3.31-1.38c0.85-0.85,1.38-2.03,1.38-3.31V11.32c0-1.29-0.53-2.46-1.38-3.32C114.02,7.15,112.85,6.62,111.56,6.62 L111.56,6.62z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.1709f408.svg";
export { ForwardRef as ReactComponent };